import { NAME_DOCUMENT_FOR_GAME_INFOR, ENUM_STATUS_GAME , LIST_COMMON_SHADOW , LIST_SHADOW_INDEX } from "constants"

import React, { useState, useEffect } from "react"

import BoxButton from "components/BoxButton"
import CustomButton from "components/CustomButton"
import { updateDocument } from "firebase-helper/firestore-services"
import { FaGreaterThan, FaLessThan } from "react-icons/fa"
import { IoHandLeftOutline, IoHandRightOutline } from "react-icons/io5"
import { showNotification } from "utils"

import Title from "../common/Title"
import Waitinggif from "../common/WaitingGif"


const SetShadow = ({ roomId, canSetShadow }) => {
    const [indexes, setIndexes] = useState([])
    const [isBiggestNum, setIsBiggestNum] = useState(true)
    const [isHandLeft, setIsHandLeft] = useState(true)

    useEffect(() => {
        if (canSetShadow){
            showNotification("", "🦄 Mời bạn yêu giao bóng ^^", {
                autoClose: 1998
            })
        }
    }, [canSetShadow])

    const handleSetIndexes = (index) => {
        if (indexes.some((i) => index === i)){
            setIndexes((prev) => prev.filter((idx) => idx !== index))

            return
        }
        setIndexes((prev) => [...prev, index])
    }

    const handleSetShadow = (sd) => {
        setIndexes(sd.indexes)
        setIsBiggestNum(sd.isBiggestNum)
    }

    const handleStart = async() => {
        if (indexes.length === 0){
            showNotification("error", "Bạn yêu chưa chọn bóng ^^")

            return
        }

        await updateDocument(NAME_DOCUMENT_FOR_GAME_INFOR, roomId, {
            status : ENUM_STATUS_GAME.GET_SHADOW,
            shadow : {
                indexes,
                is_biggest_num : isBiggestNum,
                is_hand_left   : isHandLeft,
                extends        : {
                    math_sign : "+",
                    num       : 0
                }
            }
        })
    }

    if (canSetShadow){
        return (
            <div className="">
                <Title>1. Giao bóng</Title>

                <p className="text-quinary text-sm italic mt-4">1 số kiểu bóng hay được gọi</p>

                <div className="flex flex-wrap gap-2 mt-2">
                    { LIST_COMMON_SHADOW.map((item, i) => (
                        <div
                            className={ `hover:bg-border rounded-lg border-solid	 border-2 border-black cursor-pointer flex-center px-3 py-2` }
                            key={ i }
                            onClick={ () => handleSetShadow(item) }
                        >
                            <p className="font-semibold text-sm">{ item.title }</p>
                        </div>
                    )) }
                </div>

                <p className="tablet:mt-8 mt-6 font-semibold text-lg tracking-wide">Chọn bóng</p>

                <div className="flex flex-wrap gap-2 mt-2">
                    { LIST_SHADOW_INDEX.map((index, i) => (
                        <div
                            className={ ` ${
                                indexes.some((idx) => idx === i)
                                    ? "bg-primary--light text-white"
                                    : "hover:bg-border"
                            } border-solid	 rounded-full border-2 border-black cursor-pointer flex-center  h-9 w-9` }
                            key={ i }
                            onClick={ () => handleSetIndexes(i) }
                        >
                            <p className="font-semibold text-lg">{ index }</p>
                        </div>
                    )) }
                </div>


                <div className="tablet:mt-8 mt-6">
                    <p className="font-semibold text-lg">Giá trị bóng</p>

                    <div className="flex space-x-3 mt-2">
                        <BoxButton
                            className={ `${
                                isBiggestNum ? "bg-primary--light text-white border-0" : ""
                            }` }
                            icon={ <FaGreaterThan size={ 24 } /> }
                            title="Lớn ăn"
                            onClick={ () => setIsBiggestNum(true) }
                        />

                        <BoxButton
                            className={ `${
                                !isBiggestNum ? "bg-primary--light text-white border-0" : ""
                            }` }
                            icon={ <FaLessThan size={ 24 } /> }
                            title="Bé ăn"
                            onClick={ () => setIsBiggestNum(false) }
                        />
                    </div>
                </div>

                <div className="tablet:mt-8 mt-6">
                    <p className="font-semibold text-lg">Chọn tay lấy bóng</p>

                    <div className="flex space-x-3 mt-2">
                        <BoxButton
                            className={ `${
                                isHandLeft ? "bg-primary--light text-white border-0" : ""
                            }` }
                            icon={ <IoHandLeftOutline size={ 24 } /> }
                            title="Tay trái"
                            onClick={ () => setIsHandLeft(true) }
                        />

                        <BoxButton
                            className={ `${
                                !isHandLeft ? "bg-primary--light text-white border-0" : ""
                            }` }
                            icon={ <IoHandRightOutline size={ 24 } /> }
                            title="Tay phải"
                            onClick={ () => setIsHandLeft(false) }
                        />
                    </div>
                </div>


                <CustomButton className="w-full h-[44px] mt-10" onClick={ handleStart }>
                    Bắt đầu
                </CustomButton>
            </div>
        )
    }

    return (
        <div>
            <Title>1. Giao bóng</Title>

            <p className="text-center font-semibold text-lg tracking-wide">
                Đối phương đang giao bóng . Xin bạn yêu chờ 1 lúc ^^
            </p>

            <Waitinggif className="flex-center tablet:mt-8 mt-6" />
        </div>
    )
}

export default SetShadow
